import axios from 'axios';
import { requestHideLoader, requestShowLoader } from '../Global/action';
import * as actionType from './type';


export const requestGetAllPermission = () => async(dispatch) => {
    try {

        const headerReq = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
            }
        }

        dispatch(requestShowLoader());

        const responseData = await axios.get(`${process.env.REACT_APP_ORDER_URL}permissions`, headerReq );

        const {data} = responseData;
        dispatch({
            type: actionType?.RECEIVED_ALL_PERMISSION_TYPE,
            payload: data
        })
        dispatch(requestHideLoader());
    } catch(error) {
        dispatch(requestHideLoader());
    }
}

export const requestGetAllRoles = () => async(dispatch) => {
    try {

        const headerReq = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
            }
        }

        dispatch(requestShowLoader());

        const responseData = await axios.get(`${process.env.REACT_APP_ORDER_URL}roles`, headerReq );

        const {data} = responseData;

        dispatch({
            type: actionType?.RECEIVED_ALL_ROLES,
            payload: data
        })
        
        dispatch(requestHideLoader());
    } catch(error) {
        dispatch(requestHideLoader());
    }
}
